import { gql } from '@apollo/client';

export const UPDATE_USER_PASSWORD = gql`
    mutation UpdateUserPassword(
        $userId: Int!, 
        $token: String!,
        $newPassword: String!
    ) {
        updateUserPassword (
            userId: $userId,
            token: $token, 
            newPassword: $newPassword
        ) {
            success,
        }
    }

`
